module.exports = __webpack_public_path__ + "static/media/Azure_Enabling_GPU_Metrics_Serra_Labs.cd6e73a7.pdf";